import { render, staticRenderFns } from "./SpaceVisualizer.vue?vue&type=template&id=132bb2c5&"
import script from "./SpaceVisualizer.vue?vue&type=script&lang=js&"
export * from "./SpaceVisualizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports